import type { Action } from 'redux';
import NotificationActions from '../../../../../main/actions/NotificationActions';
import dash_api from '../../../../../main/support/dash_api';
import type { Rule } from '../../../../../main/types/journeyTypes';
import { ReduxAsyncAction } from '../../../../services/ReduxAsyncAction';
import type { ActionNamespaceConstants } from '../../../../types/ReduxAsyncActions.types';

type APIResponseType = Rule;

type ActionResponseType = Rule;

const FetchMainActiveJourney = new ReduxAsyncAction<'FETCH_MAIN_ACTIVE_JOURNEY', string, ActionResponseType>(
  'FETCH_MAIN_ACTIVE_JOURNEY'
);

FetchMainActiveJourney.registerRequest(async (journeyId: string) => {
  try {
    const { data: journey } = await dash_api.get<APIResponseType>(`/v1/audience_rule/${journeyId}`);
    return journey;
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch Journey for history report', 'error');
    throw error;
  }
});

export const FETCH_MAIN_ACTIVE_JOURNEY: ActionNamespaceConstants<'FETCH_MAIN_ACTIVE_JOURNEY'> =
  FetchMainActiveJourney.actionNamespaceConstants;

export const fetchMainActiveJourney = FetchMainActiveJourney.request;

type ActionType = ActionNamespaceConstants<'FETCH_MAIN_ACTIVE_JOURNEY'>;

export type FetchMainActiveJourneyResponseAction = Action<ActionType | string> & { data: Rule };
